export default "__VITE_ASSET__BjnSn7gc__"